import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=2b9034e1&scoped=true&lang=pug&"
import script from "./GlobalSearch.vue?vue&type=script&lang=js&"
export * from "./GlobalSearch.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=2b9034e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9034e1",
  null
  
)

export default component.exports